import EnvStorageValueGetterInterface from "./EnvStorageValueGetterInterface.js";

class EnvStorageValueGetter extends EnvStorageValueGetterInterface {
    constructor(envStorage, env) {
        super();
        this.envStorage = envStorage;
        this.env = env;
    }

    get = (key) => {
        return this.envStorage.get(this.env, key);
    }
}

export default EnvStorageValueGetter;